module.exports = __webpack_public_path__ + "static/media/LogoCircleWhite.712ca74a.jpg";